import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../FormInput/FormInput';
import FromInputTitle from '../../FormFieldTitle/FormFieldTitle';
import T, { t } from '../../../../../common/components/T';
import { LangContext } from '../../../../../common/decorators/Language';
import css from './FormRangeValues.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';

const FormRange = (props) => {
    const { translation } = useContext(LangContext) || {};
    const { stylers, classes } = generateCompStylers(props?.compStyle);
    return (
        <>
            <div style={stylers.wrapper} className={classnames(classes.wrapper)}>
                {!!props.title && (
                    <FromInputTitle
                        variationStyle={'separated_title'}
                        type={props.type}
                        errors={props.errors}
                        title={props.title}
                        compStyle={props.compStyle}
                        hint={props.hint}
                        required={props.required}
                    />
                )}
                <div style={stylers.flex} className={classnames(css.formRangeFlex, classes.flex)}>
                    {props.options.map((option, index) => (
                        <React.Fragment key={`range_${option}`}>
                            {props.placeholder === false ? (
                                <FormInput
                                    {...props}
                                    value={
                                        !!props?.value
                                            ? props?.value[option] || null
                                            : !!props?.formData
                                            ? props?.formData[option] || null
                                            : null
                                    }
                                    compStyle={props?.compStyle[option] || {}}
                                    attribute={option}
                                    placeholder={
                                        index === 0 ? t('from', 'От', 'all', translation) : t('to', 'До', 'all', translation)
                                    }
                                    title={false}
                                />
                            ) : (
                                <FormInput
                                    {...props}
                                    value={
                                        !!props?.value
                                            ? props?.value[option] || null
                                            : !!props?.formData
                                            ? props?.formData[option] || null
                                            : null
                                    }
                                    compStyle={props?.compStyle[option] || {}}
                                    attribute={option}
                                    title={{
                                        body: props?.titles?.[index] ? (
                                            props?.titles[index]
                                        ) : index === 0 ? (
                                            <T textName='from' defaultStr='От' page='all' />
                                        ) : (
                                            <T textName='to' defaultStr='До' page='all' />
                                        )
                                    }}
                                />
                            )}
                            {index === 0 && (
                                <div
                                    style={stylers.separator}
                                    className={classnames(css.formRangeSeparator, classes.separator)}
                                />
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </>
    );
};
FormRange.propTypes = { options: PropTypes.array, value: PropTypes.object };
export default FormRange;
